var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-overlay",
    { attrs: { show: _vm.loading } },
    [
      _c(
        "div",
        { staticClass: "d-flex justify-content-center align-items-center" },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: "Ver detalle",
                  expression: "'Ver detalle'"
                }
              ]
            },
            [
              _c(
                "b-button",
                {
                  staticClass: "btn-icon rounded-circle p-3",
                  attrs: {
                    variant: "secondary",
                    size: "sm",
                    "data-cy": "details"
                  },
                  on: {
                    click: function($event) {
                      return _vm.onOptionDetailBatch(_vm.batch)
                    }
                  }
                },
                [_c("feather-icon", { attrs: { icon: "SearchIcon" } })],
                1
              )
            ],
            1
          ),
          _vm._t(
            "action-list",
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: "Desplegar acciones",
                      expression: "'Desplegar acciones'"
                    }
                  ]
                },
                [
                  _c(
                    "b-dropdown",
                    {
                      directives: [
                        {
                          name: "has-permission",
                          rawName: "v-has-permission",
                          value: "ED185",
                          expression: "'ED185'"
                        }
                      ],
                      attrs: { variant: "link", "no-caret": "", right: "" },
                      scopedSlots: _vm._u([
                        {
                          key: "button-content",
                          fn: function() {
                            return [
                              _c("feather-icon", {
                                staticClass: "align-middle text-body",
                                attrs: {
                                  "data-cy": "gear-button",
                                  width: "24px",
                                  height: "24px",
                                  icon: "SettingsIcon"
                                }
                              })
                            ]
                          },
                          proxy: true
                        }
                      ])
                    },
                    [
                      _c(
                        "CheckPermission",
                        { attrs: { permission: "ED166" } },
                        [
                          _c(
                            "b-dropdown-item",
                            {
                              attrs: { "data-cy": "binnacle" },
                              on: {
                                click: function($event) {
                                  return _vm.onOptionBatchBinnacle(_vm.batch)
                                }
                              }
                            },
                            [
                              _c("vs-icon", { attrs: { icon: "list" } }),
                              _vm._v(" Bitácora ")
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm.view !== "batchs-review"
                        ? _c(
                            "CheckPermission",
                            { attrs: { permission: "ED170" } },
                            [
                              _vm.EDIT_STATES.includes(_vm.batch.estado)
                                ? _c(
                                    "b-dropdown-item",
                                    {
                                      attrs: { "data-cy": "edit" },
                                      on: {
                                        click: function($event) {
                                          return _vm.onOptionEditBatch(
                                            _vm.batch
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("vs-icon", {
                                        attrs: { icon: "edit" }
                                      }),
                                      _vm._v(" Editar ")
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "CheckPermission",
                        { attrs: { permission: "ED171" } },
                        [
                          _c(
                            "b-dropdown-item",
                            {
                              attrs: { "data-cy": "visualize" },
                              on: {
                                click: function($event) {
                                  return _vm.onOptionVisualizeBatch(_vm.batch)
                                }
                              }
                            },
                            [
                              _c("vs-icon", {
                                attrs: { icon: "content_paste" }
                              }),
                              _vm._v(" Visualizar ")
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "CheckPermission",
                        { attrs: { permission: "ED167" } },
                        [
                          _vm.APPROVE_STATES.includes(_vm.batch.estado) &&
                          _vm.view === "batchs-review"
                            ? _c(
                                "b-dropdown-item",
                                {
                                  attrs: { "data-cy": "approve" },
                                  on: {
                                    click: function($event) {
                                      return _vm.onOptionBatchAprove(_vm.batch)
                                    }
                                  }
                                },
                                [
                                  _c("vs-icon", {
                                    attrs: { icon: "thumb_up" }
                                  }),
                                  _vm._v(" Aprobar ")
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "CheckPermission",
                        { attrs: { permission: "ED186" } },
                        [
                          _vm.REJECT_STATES.includes(_vm.batch.estado) &&
                          _vm.view === "batchs-review"
                            ? _c(
                                "b-dropdown-item",
                                {
                                  attrs: { "data-cy": "cancel" },
                                  on: {
                                    click: function($event) {
                                      return _vm.onOptionBatchReject(_vm.batch)
                                    }
                                  }
                                },
                                [
                                  _c("vs-icon", {
                                    attrs: { icon: "thumb_down" }
                                  }),
                                  _vm._v(" Rechazar ")
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm.view !== "batchs-review"
                        ? _c(
                            "CheckPermission",
                            { attrs: { permission: "ED168" } },
                            [
                              _vm.RESCUE_STATES.includes(_vm.batch.estado)
                                ? _c(
                                    "b-dropdown-item",
                                    {
                                      attrs: { "data-cy": "rescue" },
                                      on: {
                                        click: function($event) {
                                          return _vm.onOptionBatchRescue(
                                            _vm.batch
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("vs-icon", {
                                        attrs: { icon: "assessment" }
                                      }),
                                      _vm._v(" Rescatar ")
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.view !== "batchs-review"
                        ? _c(
                            "CheckPermission",
                            { attrs: { permission: "*" } },
                            [
                              _vm.EDIT_STATES.includes(_vm.batch.estado)
                                ? _c(
                                    "b-dropdown-item",
                                    {
                                      attrs: { "data-cy": "main-photo" },
                                      on: {
                                        click: function($event) {
                                          return _vm.onOptionBatchPicture(
                                            _vm.batch
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("vs-icon", {
                                        attrs: { icon: "photo" }
                                      }),
                                      _vm._v(" Imágenes ")
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.view !== "batchs-review"
                        ? _c(
                            "CheckPermission",
                            { attrs: { permission: "ED173" } },
                            [
                              _vm.POSTULE_STATES.includes(_vm.batch.estado)
                                ? _c(
                                    "b-dropdown-item",
                                    {
                                      attrs: { "data-cy": "apply-auction" },
                                      on: {
                                        click: function($event) {
                                          return _vm.onOptionBatchPostule(
                                            _vm.batch
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("vs-icon", {
                                        attrs: { icon: "add_circle" }
                                      }),
                                      _vm._v(" Agregar a subasta ")
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.batch.estado === _vm.batchesCodeSates.creado &&
                      _vm.view !== "batchs-review"
                        ? _c(
                            "CheckPermission",
                            { attrs: { permission: "ED169" } },
                            [
                              _c(
                                "b-dropdown-item",
                                {
                                  attrs: { "data-cy": "validate" },
                                  on: {
                                    click: function($event) {
                                      return _vm.onOptionValidateBatch(
                                        _vm.batch,
                                        _vm.batchesActionStates.VALIDAR
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("vs-icon", {
                                    attrs: { icon: "verified_user" }
                                  }),
                                  _vm._v(" Validar ")
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.batch.estado === _vm.batchesCodeSates.publicado &&
                      _vm.view !== "batchs-review" &&
                      !_vm.canReturn
                        ? _c(
                            "CheckPermission",
                            { attrs: { permission: "ED187" } },
                            [
                              _c(
                                "b-dropdown-item",
                                {
                                  attrs: { "data-cy": "adjudge" },
                                  on: {
                                    click: function($event) {
                                      return _vm.onOptionPopUpAdjudge(_vm.batch)
                                    }
                                  }
                                },
                                [
                                  _c("vs-icon", {
                                    attrs: { icon: "attach_money" }
                                  }),
                                  _vm._v(" Adjudicar ")
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.view !== "batchs-review"
                        ? _c(
                            "CheckPermission",
                            { attrs: { permission: "ED172" } },
                            [
                              _vm.CANCEL_STATES.includes(_vm.batch.estado)
                                ? _c(
                                    "b-dropdown-item",
                                    {
                                      attrs: { "data-cy": "cancel" },
                                      on: {
                                        click: function($event) {
                                          return _vm.onOptionBatchCancel(
                                            _vm.batch
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("vs-icon", {
                                        attrs: { icon: "highlight_off" }
                                      }),
                                      _vm._v(" Anular ")
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.view !== "batchs-review"
                        ? _c(
                            "CheckPermission",
                            { attrs: { permission: "ED220" } },
                            [
                              _vm.canReturn
                                ? _c(
                                    "b-dropdown-item",
                                    {
                                      attrs: { "data-cy": "return" },
                                      on: {
                                        click: function($event) {
                                          return _vm.onOptionBatchReturn(
                                            _vm.batch
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("vs-icon", {
                                        attrs: { icon: "replay" }
                                      }),
                                      _vm._v(" Devolver ")
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.view !== "batchs-review"
                        ? _c(
                            "CheckPermission",
                            { attrs: { permission: "ED225" } },
                            [
                              _vm.canDonate
                                ? _c(
                                    "b-dropdown-item",
                                    {
                                      attrs: { "data-cy": "donate" },
                                      on: {
                                        click: function($event) {
                                          return _vm.onOptionBatchDonate(
                                            _vm.batch
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("vs-icon", {
                                        attrs: { icon: "store" }
                                      }),
                                      _vm._v(" Donar ")
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.view !== "batchs-review"
                        ? _c(
                            "CheckPermission",
                            { attrs: { permission: "ED226" } },
                            [
                              _vm.canDonate
                                ? _c(
                                    "b-dropdown-item",
                                    {
                                      attrs: { "data-cy": "destroy" },
                                      on: {
                                        click: function($event) {
                                          return _vm.onOptionBatchDestroy(
                                            _vm.batch
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("vs-icon", {
                                        attrs: { icon: "delete" }
                                      }),
                                      _vm._v(" Destruir ")
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            { batch: _vm.batch }
          )
        ],
        2
      ),
      _c(
        "b-modal",
        {
          ref: "batch-detail-" + _vm.batch.loteId,
          attrs: {
            id: "batch-detail-" + _vm.batch.loteId,
            title: "Detalles del Lote Nº " + _vm.batch.folio,
            "no-close-on-backdrop": "",
            size: "lg",
            "hide-footer": ""
          }
        },
        [_c("BatchDetail", { attrs: { batch: _vm.batch } })],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "batch-rescue-" + _vm.batch.loteId,
          attrs: {
            id: "batch-rescue-" + _vm.batch.loteId,
            title:
              "¿Realmente desea Rescatar el Lote N° " + _vm.batch.folio + "?",
            "no-close-on-backdrop": "",
            size: "md",
            "hide-footer": ""
          }
        },
        [
          _c("BatchRescue", {
            attrs: { batch: _vm.batch },
            on: { rescue: _vm.onRescueBatch }
          })
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "batch-picture-" + _vm.batch.loteId,
          attrs: {
            id: "batch-picture-" + _vm.batch.loteId,
            title: "Imágenes adjuntas de Lote N° " + _vm.batch.folio,
            "no-close-on-backdrop": "",
            size: "lg",
            "hide-footer": ""
          }
        },
        [
          _c("BatchPicture", {
            attrs: { batch: _vm.batch },
            on: {
              "close-modal": function($event) {
                return _vm.closeModal()
              },
              "edit-images": function($event) {
                return _vm.onEditBatch()
              }
            }
          })
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "batch-postule-" + _vm.batch.loteId,
          attrs: {
            id: "batch-postule-" + _vm.batch.loteId,
            title: "Agregar Lote N° " + _vm.batch.folio + " a subasta",
            "no-close-on-backdrop": "",
            size: "xl",
            "hide-footer": ""
          }
        },
        [
          _c("BatchPostule", {
            attrs: { "batch-ids": [_vm.batch.loteId] },
            on: { postule: _vm.handleOnPostule }
          })
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "batch-cancel-" + _vm.batch.loteId,
          attrs: {
            id: "batch-cancel-" + _vm.batch.loteId,
            title: "Anular Lote N° " + _vm.batch.folio,
            "hide-footer": ""
          }
        },
        [
          _c("BatchCancel", {
            attrs: { batch: _vm.batch },
            on: { cancel: _vm.handleOnCancel }
          })
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "batch-reject-" + _vm.batch.loteId,
          attrs: {
            id: "batch-reject-" + _vm.batch.loteId,
            title: "Rechazar Lote N° " + _vm.batch.folio,
            "hide-footer": ""
          }
        },
        [
          _c("BatchReject", {
            attrs: { batch: _vm.batch },
            on: { cancel: _vm.handleOnReject }
          })
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "batch-approve-" + _vm.batch.loteId,
          attrs: {
            id: "batch-approve-" + _vm.batch.loteId,
            title: "Aprobar Lote N° " + _vm.batch.folio,
            "hide-footer": ""
          }
        },
        [
          _c("BatchApprove", {
            attrs: { batch: _vm.batch },
            on: { approve: _vm.handleOnApprove }
          })
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "batch-adjudge-" + _vm.batch.loteId,
          attrs: {
            id: "batch-adjudge-" + _vm.batch.loteId,
            title: "Adjudicación de Lote Nº " + _vm.batch.folio,
            "no-close-on-backdrop": "",
            size: "lg",
            "hide-footer": ""
          }
        },
        [
          _c("BatchAdjudge", {
            attrs: { batch: _vm.batch },
            on: { adjudge: _vm.handleOnAdjudge }
          })
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "batch-return-" + _vm.batch.loteId,
          attrs: {
            id: "batch-return-" + _vm.batch.loteId,
            title: "Devolver Lote Nº " + _vm.batch.folio,
            "no-close-on-backdrop": "",
            size: "md",
            "hide-footer": ""
          }
        },
        [
          _c("BatchReturn", {
            attrs: { batch: _vm.batch },
            on: { return: _vm.handleOnReturn }
          })
        ],
        1
      ),
      _c("ModalBinnacle", {
        ref: "binnacle-" + _vm.batch.loteId,
        attrs: {
          batch: _vm.batch,
          title: "Bitácora del Lote Nº " + _vm.batch.folio,
          id: "binnacle-" + _vm.batch.loteId
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }